import React, {useEffect, useState} from "react";
import AudioRecording from "./AudioRecording";
import {FetchStatisticData} from "./FetchStatisticData";
import firebase from "firebase";
import QuizGraph from "./QuizGraph";
import {CreateQuizData} from "./CreateQuizData";
import FetchQuizAssignment from "./FetchQuizAssignment";
import {CreatePageName} from './CreatePageName'
import {CreateCSVFile} from "./CreateCSVFile";
import {HandleClearAssignmentData} from "./HandleClearAssignmentData";
import {HandleClearQuizData} from "./HandleClearQuizData";

//Holds all the logic for fetching/displaying student data
function AudioRecordingWrapper(
    {
        statisticChoice,
        classLevel,
        assignment
    }
) {

    const [studentData, setStudentData] = useState([]);
    const [assignmentNum, setAssignmentNum] = useState();
    const [CSVFile, setCSVFile] = useState(null);
    const [dataFetched, setDataFetched] = useState(false);
    const [pageName, setPageName] = useState('');

    //Used for quiz statistics
    const [totalHintsUsed] = useState([])
    const [quizGraph, setQuizGraph] = useState([]);
    const [assignmentData, setAssignmentData] = useState([]);

    useEffect(() => {
        //Helper function to create nice Title for statistics page
        setPageName(CreatePageName(statisticChoice))
        if (assignment) {
            //used for title in statistics page
            setAssignmentNum(assignment.match(/(\d+)/)[0]);
            function fetchData() {
                let tmpStudentData = [];

                //calls helper function to fetch student data files
                FetchStatisticData(classLevel, statisticChoice).then((res) => {
                    setCSVFile(CreateCSVFile(res, assignment.match(/(\d+)/)[0] - 1, false));

                    //for each student entry, find the data file matching the assignment number
                    //Then, fetch the student audio file associated with the student/assignment number/page
                    for (let i = 0; i < res.length; i++) {
                        for (let w = 0; w < res[i].assignmentNum.length; w++) {
                            if (res[i].assignmentNum[w] == assignment.match(/(\d+)/)[0] - 1) {
                                firebase.storage().ref().child('students/studentAudio/' + res[i].soundFileName[w])
                                    .getDownloadURL().then((url) => {
                                    tmpStudentData.push({
                                        email: res[i].email,
                                        url: url,
                                        date: res[i].date[w]
                                    })

                                })
                            }
                        }


                    }
                });
                setStudentData(tmpStudentData)
            }

            if (statisticChoice !== 'quizAssignments') {
                fetchData()
            }

            //fetching quiz data separately because data looks different
            function fetchQuizData() {
                FetchStatisticData(classLevel, statisticChoice).then((res) => {
                    for(let i = 0; i < res.length; i ++){
                        let count = 0;
                        for(let n = 0; n < res[i].hint[(assignment.match(/\d+/)[0] - 1)].length; n++){

                            //fetching only the assignment the admin is looking for
                            if(res[i].hint[(assignment.match(/\d+/)[0] - 1)][n] == 1){
                                count++;
                            }
                        }
                        totalHintsUsed.push(count)
                    }
                    setCSVFile(CreateCSVFile(res, assignment.match(/(\d+)/)[0] - 1,true, totalHintsUsed))
                    setQuizGraph(CreateQuizData(res, (assignment.match(/\d+/)[0] - 1)))
                    setStudentData(res);

                }).then(() => {
                    setDataFetched(true)
                });
                FetchQuizAssignment(classLevel, assignment).then((res) => {
                    setAssignmentData(res)
                })
            }

            if (statisticChoice === 'quizAssignments') {
                fetchQuizData();

            }
        }

    }, [statisticChoice, classLevel, assignment]);

    //Function call to clear assignment student data
    const handleClearAssignmentData = () => {
        let tmpStudentData = [];
        if (statisticChoice !== 'quizAssignments') {
            HandleClearAssignmentData(classLevel, statisticChoice, (assignmentNum - 1))
                .then((res) => {
                    for (let i = 0; i < res.length; i++) {
                        for (let w = 0; w < res[i].assignmentNum.length; w++) {
                            if (res[i].assignmentNum[w] == assignment.match(/(\d+)/)[0] - 1) {
                                firebase.storage().ref().child('students/studentAudio/' + res[i].soundFileName[w])
                                    .getDownloadURL().then((url) => {
                                    tmpStudentData.push({
                                        email: res[i].email,
                                        url: url,
                                        date: res[i].date[w]
                                    })

                                })
                            }
                        }
                    }
                    setStudentData(tmpStudentData)
                });
        }
        if (statisticChoice === 'quizAssignments') {
            HandleClearQuizData(classLevel, assignment, (assignmentNum-1)).then((res) => {
                setQuizGraph(CreateQuizData(res, (assignment.match(/\d+/)[0] - 1)))
                setStudentData(res);
            })
        }

    };

    return (
        <>
            {
                statisticChoice === 'quizAssignments' ?
                    <QuizGraph
                        studentData={studentData}
                        statisticChoice={statisticChoice}
                        assignment={assignment}
                        quizGraph={quizGraph}
                        assignmentNum={assignmentNum}
                        assignmentData={assignmentData}
                        CSVFile={CSVFile}
                        dataFetched={dataFetched}
                        handleClearAssignmentData={handleClearAssignmentData}
                        totalHintsUsed={totalHintsUsed}
                    />
                    :
                    <AudioRecording
                        studentData={studentData}
                        statisticChoice={statisticChoice}
                        assignment={assignment}
                        assignmentNum={assignmentNum}
                        pageName={pageName}
                        CSVFile={CSVFile}
                        handleClearAssignmentData={handleClearAssignmentData}
                        classLevel={classLevel}
                    />
            }

        </>
    )
}

export default AudioRecordingWrapper
